"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextEllipsis = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var tooltip_1 = __importDefault(require("../tooltip"));
exports.TextEllipsis = function (_a) {
    var _b, _c, _d, _e;
    var children = _a.children, className = _a.className, rows = _a.rows, tooltipOnEllipsis = _a.tooltipOnEllipsis, tooltipProps = _a.tooltipProps, style = _a.style, otherProps = __rest(_a, ["children", "className", "rows", "tooltipOnEllipsis", "tooltipProps", "style"]);
    var _f = __read(React.useState(false), 2), showTooltip = _f[0], setShowTooltip = _f[1];
    var handleMouseEnter = function (event) {
        var element = event.currentTarget;
        var showTooltip = isTextTruncated(element);
        setShowTooltip(showTooltip);
    };
    var handleMouseLeave = function () {
        setShowTooltip(false);
    };
    var getTextEllipsisHTML = function () {
        return (React.createElement("span", __assign({ className: classnames_1.default(className, 'tk-text-ellipsis', { 'tk-text-ellipsis__multiple-rows': rows > 1 }), style: __assign({ WebkitLineClamp: rows }, style), onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, otherProps), children));
    };
    if (!(tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.description) && !children) {
        return null;
    }
    if (tooltipOnEllipsis) {
        return (React.createElement(tooltip_1.default, __assign({}, tooltipProps, { description: (_b = tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.description) !== null && _b !== void 0 ? _b : children, placement: (_c = tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.placement) !== null && _c !== void 0 ? _c : 'top', type: (_d = tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.type) !== null && _d !== void 0 ? _d : 'tooltip', visible: (_e = tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.visible) !== null && _e !== void 0 ? _e : showTooltip }), getTextEllipsisHTML()));
    }
    else {
        return (getTextEllipsisHTML());
    }
};
exports.TextEllipsis.defaultProps = {
    rows: 1,
    tooltipOnEllipsis: true,
};
var isTextTruncated = function (element) {
    var scrollWidth = element.scrollWidth, scrollHeight = element.scrollHeight, clientWidth = element.clientWidth, clientHeight = element.clientHeight;
    return (scrollHeight > clientHeight) || (scrollWidth > clientWidth);
};
